<script setup lang="ts">
import { ITargetStatus } from "@/features/driver-status/driver-status.types";

interface IStatusProps {
  label: ITargetStatus;
}

const props = withDefaults(defineProps<IStatusProps>(), {
  label: "off",
});

const getBack = () => {
  if (props.label == "off") {
    return "#9b9daa";
  } else if (props.label == "sleep") {
    return "#f99e2c";
  } else if (props.label == "driving") {
    return "#27ae60";
  } else if (props.label == "on") {
    return "#409cff";
  } else if (props.label == "yard") {
    return "#409cff";
  } else if (props.label == "any") {
    return "#ffdfe3";
  } else {
    return "#9b9daa";
  }
};

const getLabel = () => {
  if (props.label == "off") {
    return "OFF";
  } else if (props.label == "sleep") {
    return "SB";
  } else if (props.label == "driving") {
    return "DR";
  } else if (props.label == "on") {
    return "ON";
  } else if (props.label == "yard") {
    return "YM";
  } else if (props.label == "personal") {
    return "PC";
  } else if (props.label == "any") {
    return "ANY";
  } else {
    return "NONE";
  }
};
</script>

<template>
  <div class="c-cu-status-badge" :style="{ background: getBack() }">
    {{ getLabel() }}
  </div>
</template>

<style scoped lang="scss">
.c-cu-status-badge {
  display: inline-block;
  border-radius: 8px;
  padding: 4px 8px;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  letter-spacing: 0;
  color: var(--color-white);
  text-transform: uppercase;
}
</style>
